"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var APP_STATE_CONSTANTS;
(function (APP_STATE_CONSTANTS) {
    APP_STATE_CONSTANTS["BOOT"] = "otyyeXMBiZisi3bCk1eDU4";
    APP_STATE_CONSTANTS["RESET"] = "kqUsEPYf24i3Afp3uQNA3x";
    APP_STATE_CONSTANTS["UPDATE_CONTROL_BY_ID"] = "pZngUmpEc2eBVh51AohSxi";
    APP_STATE_CONSTANTS["UPDATE_ROUTE_STACK"] = "fYTGrSEhhzXreNvEJ6w5PA";
    APP_STATE_CONSTANTS["UPDATE_RUNNING_MODE"] = "guQFQoemduypKK12DSNasm";
    APP_STATE_CONSTANTS["UPDATE_DB_CACHE"] = "h5dzERPxRvwE7LBrJAHZD8";
    APP_STATE_CONSTANTS["OVERWRITE_DB_CACHE"] = "s9481a9rrURUkc7hrHPPeb";
    APP_STATE_CONSTANTS["UPDATE_LOCAL_STORAGE"] = "6ZJXbsHkDwsghHUb3inz6v";
    APP_STATE_CONSTANTS["CLEAN_LOCAL_STORAGE"] = "5J6D58fixuxYTGWhaHdhsn";
    APP_STATE_CONSTANTS["BOOT_LOCAL_STORAGE"] = "dbaN2jaMfmwr6kysHmpJqg";
    APP_STATE_CONSTANTS["CLEAN_LOCAL_STORAGE_LISTENERS"] = "smepawVN2ogCDDdf2UyHoA";
    APP_STATE_CONSTANTS["ADD_LOCAL_STORAGE_LISTENER"] = "r4fFZY1Srpp3DnNASzEQG6";
    APP_STATE_CONSTANTS["OPEN_CAMERA"] = "wJokWRSf2Cma4ytqNaa14A";
    APP_STATE_CONSTANTS["UPDATE_INPUTDIALOG_CONTEXT"] = "dVsjnENCCgYZRfokhrQ8zi";
    APP_STATE_CONSTANTS["UPDATE_ALERT_CONTEXT"] = "iR3zjM9STGWhaHdhsn";
    APP_STATE_CONSTANTS["UPDATE_CONFIRM_ALERT_CONTEXT"] = "a4vhAoFGeWRhpRV2WEKaVN";
    APP_STATE_CONSTANTS["UPDATE_ADMOB_INTERSTITIAL_CONTEXT"] = "c2Nntz9xWoQ4d239so2VXo";
    APP_STATE_CONSTANTS["SET_IS_BOTTOM_MENU_OPENED"] = "onx9fYKfVYZwVSPBz1LLW2";
    APP_STATE_CONSTANTS["SET_IS_LOADING_PAGE_OPENED"] = "GoJjxemePHsjMCMCcuuTM";
    APP_STATE_CONSTANTS["SET_IS_SIDE_MENU_OPENED"] = "skt8vofufsZR3i731uF2G9";
    APP_STATE_CONSTANTS["UPDATE_CONTROL_PROP_BY_PATH_IF_EXIST"] = "qepJCYssK7fKgfd9xrwJJH";
    APP_STATE_CONSTANTS["UPDATE_CONTROL_TO_LIST"] = "iR3zjM9SCUDhSKt1WAajoj";
    APP_STATE_CONSTANTS["UPDATE_SWIPER_CONTENT"] = "nTF69Bw4wG5H9cSKeximAc";
    APP_STATE_CONSTANTS["ADD_ITEMS_TO_FLAT_LIST"] = "7seTf7ir68pvWzCxeSsAxq";
    APP_STATE_CONSTANTS["SET_CUSTOM_FONT_NAME"] = "wQYF1iZ2gnpAbDeYWN5w6h";
    APP_STATE_CONSTANTS["UPDATE_PALETTE_COLORS"] = "onx9fYKir68pvWzCxeSsAxq";
    APP_STATE_CONSTANTS["SET_TRANSITION_SIDE_MENU"] = "4nx9fYKir683vWzCxeSsAj3";
    APP_STATE_CONSTANTS["SET_TRANSITION_BOTTOM_MENU"] = "46587Tzxa179213asdwWzxc";
    APP_STATE_CONSTANTS["OPEN_IMAGE_VIEWER"] = "5006Tz240519999sdwWzxc";
})(APP_STATE_CONSTANTS || (APP_STATE_CONSTANTS = {}));
exports.default = APP_STATE_CONSTANTS;
